import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const RkRestartService = React.lazy(async () => ({
    default: (await import('@oc/rk-restart-service/module')).RkRestartService
}))

export function RkRestartServiceComponent() {
    return <SuspenseWhileLoading LazyComponent={RkRestartService} />
}
